import { Component, Vue, Watch } from "vue-property-decorator";
import { isIINBIN } from "@/utils";

@Component
export default class extends Vue {
  protected formRef = "form-validator-ref";
  get rules() {
    return {
      required: (value: string) => {
        return typeof value === "boolean" || typeof value === "number"
          ? true
          : !!value || this.$t("form-validator.required");
      },
      selectRequired: (value: any[]) => {
        if (!value) return true;
        return !!value.length || this.$t("form-validator.required");
      },
      stringLengthMaxMin: (max: number, min: number) => (value?: string) => {
        const fmax = this.stringLengthMax(max)(value);
        if (typeof fmax == "string") return fmax;
        const fmin = this.stringLengthMin(min)(value);
        if (typeof fmin == "string") return fmin;

        return true;
      },
      stringLengthMax: this.stringLengthMax,
      stringLengthMin: this.stringLengthMin,
      isNumber: (value: string) => {
        const x = Number.parseInt(value);
        return x !== null && !isNaN(x) || this.$t("form-validator.number");
      },
      iin: this.iinBin("iin"),
      bin: this.iinBin("bin"),
      email: (value: string) => {
        const pattern = /^(([a-z0-9A-Z-_])|([.])|([^А-Яа-я<>()[\]\\.,;:\s@"!#%*=+{}/'|]+(\.[^<>()[\]\\.,;:\s@"!#%*=+{}/'|]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-_0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || this.$t("form-validator.email");
      },
    };
  }

  validateForm() {
    //!!во всех компонентах которые используют этот примесь нужно в компоненте указать formRef-ссылка на контейнер формы
    return (this.$refs[this.formRef] as Vue & {
      validate: () => boolean;
    }).validate();
  }

  @Watch("$i18n.locale") resetFormValidation() {
    (this.$refs[this.formRef] as Vue & {
      resetValidation: () => void;
    }).resetValidation();
  }

  private iinBin(type: "iin" | "bin") {
    return (value: string) => {
      if (!value || isIINBIN(value)) return true;
      return this.$t("form-validator." + type);
    };
  }

  private stringLengthMax(max: number) {
    return (value = "") => {
      if (value && max && value.length > max) {
        return this.$t("form-validator.string-max", { max });
      }
      return true;
    };
  }
  private stringLengthMin(min: number) {
    return (value = "") => {
      if (value && min && value.length < min) {
        return this.$t("form-validator.string-min", { min });
      }
      return true;
    };
  }
}
